import { weekDays } from './glossary';

const dates = [];
let counter = 3;
for (let i = 8; i <= 25; i += 1) {
    const obj = {
        date: i,
        weekDay: weekDays[counter]
    };
    dates.push(obj);
    if (counter === 6) {
        counter = 0;
    } else {
        counter += 1;
    }
}

export default dates;



// WEBPACK FOOTER //
// ./src/static-data/dates-list.js